import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../components/common/secondary header/index";
import { TEACHER } from "../../../constants";
import { ReportClassesService } from "../../../services/reports";
import * as actions from "../../../store/actions";
import * as configActions from "../../../store/config/actions";
import "./style.scss";
import { getQueryStringParams } from './../../../helpers/index';
import { textIdentifier } from "../../../textIdentifier";
import ConfirmDownloadReportModal from "./ConfirmDownloadReportModal";

export default function AllClassesReport() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { userType, userData } = useSelector((state) => state.auth);
  const { selectedCompetition, selectedSchool,lang ,selectedClass, downloadReportError, downloadReportSuccess, downloadReportLoading } = useSelector(
    (state) => state.main
  );
  const [classes, setClasses] = useState([]);
  const [filteredClasses, setFilteredClasses] = useState([]);
  const [sortBy, setSortBy] = useState("name");
  const [isFetching, setIsFetching] = useState(true);
  const [confirmDownloadModalOpen,setConfirmDownloadModalOpen] = useState(false);

  const handleDownloadReport = () => {
    setConfirmDownloadModalOpen(true);
    dispatch(actions.downloadReport(selectedCompetition.id,selectedSchool.id));
  }

  const handleCloseDownloadReportModal = () => {
    setConfirmDownloadModalOpen(false);
  }

  const showReportButton = useMemo(() => {
    const prefs = userData?.competition_admin_preferences;
    return Array.isArray(prefs) && prefs.some((v) => Number(v) === 1);
  }, [userData]);

  const selectClass = (selectedClass, e, totalClasses, replace = false) => {
    e && e.preventDefault();
    let qParams = getQueryStringParams(location.search);
    dispatch(
      actions.selectClass(Object.assign(selectedClass, { totalClasses }))
    );
    if(!!qParams.student&&!!qParams.classCode){
      navigate(
        `/report/${selectedCompetition.id}/schools/${selectedSchool.id}/classes/${selectedClass.id}?student=${qParams.student}&classCode=${qParams.classCode}`,
        {
          replace,
        }
      );
    }
    else{
      navigate(
        `/report/${selectedCompetition.id}/schools/${selectedSchool.id}/classes/${selectedClass.id}`,
        {
          replace,
        }
      );
    }
  };

  const fetchClasses = async () => {
    try {
      const res = await ReportClassesService(
        selectedCompetition.id,
        selectedSchool.id
      );

      if (userType === TEACHER) {
        // selectClass
        const classes = res.data.filter((item) =>
          // userData.classes.includes(item.code)
          selectedClass.code == item.code
        );
        if (classes.length > 0) {
          selectClass(classes[0], null, res.data.length, true);
        } else {
          dispatch(configActions.showAlert(textIdentifier["You're-not-assigned-to-any-class"][lang]));
          navigate("/");
        }
      } else {
        setClasses(res.data);
        setFilteredClasses(res.data);
        setIsFetching(false);
        let qParams = getQueryStringParams(location.search);
        if(!!qParams.student&&!!qParams.classCode){
          for(let i of res.data){
            if(i.code == qParams.classCode){
              selectClass(i, null, res.data.length, false)
            }
          }
        }
      }
    } catch (error) {
      dispatch(configActions.showAlert(error?.data?.message));
      setIsFetching(false);
    }
  };

  useEffect(() => {
    if (!selectedCompetition || !selectedSchool) {
      navigate(`/dashboard`);
    } else {
      fetchClasses();
    }
  }, []);

  const handleSearch = (e) => {
    const { value } = e.target;
    if (value.trim()) {
      setFilteredClasses(
        classes.filter((_) =>
          _.name.toLowerCase().includes(value.toLowerCase())
        )
      );
    } else {
      setFilteredClasses(classes);
    }
  };

  const handleSortBy = (sort, e) => {
    e.preventDefault();
    if (sort == "name") {
      setFilteredClasses(
        classes
          .sort(function (a, b) {
            return a.name.localeCompare(b.name);
          })
          .sort(function (a, b) {
            if (b.rank) {
              return 1;
            } else {
              return -1;
            }
          })
      );
    }
    if (sort == "rank") {
      setFilteredClasses(
        classes
          .sort(function (a, b) {
            return a.rank - b.rank;
          })
          .sort(function (a, b) {
            if (b.rank) {
              return 1;
            } else {
              return -1;
            }
          })
      );
    }
    setSortBy(sort);
  };

  if (isFetching) {
    return <Header />;
  }
  return (
    <Fragment>
      <Header title={selectedCompetition.name} />
      <main className="Reports-list-classes">
        {/* heading card */}
        <div className="card heading-card">
          <div className="card-body">
            <span className="card-title">
              {selectedSchool.name}{" "}
              {!selectedCompetition.hide_rank &&  <span className="text-primary">({textIdentifier["rank"][lang]} {selectedSchool.rank})</span>}
            </span>
          </div>
        </div>

        <div className="cr-wrapper-card">
          <div className="cr-card-header list-header-container">
            <h5>{textIdentifier["classes"][lang]}</h5>

            <div className="dropdown">
              <button
                className="btn dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                data-bs-offset="50,12"
                aria-expanded="false"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M17 20L21 16M3 4H16H3ZM3 8H12H3ZM3 12H12H3ZM17 8V20V8ZM17 20L13 16L17 20Z"
                    stroke="#2E2E2E"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <span>{sortBy}</span>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.35183 8.75306C6.57687 8.5281 6.88204 8.40172 7.20023 8.40172C7.51843 8.40172 7.8236 8.5281 8.04863 8.75306L12.0002 12.7047L15.9518 8.75306C16.0625 8.63845 16.1949 8.54703 16.3413 8.48414C16.4878 8.42125 16.6452 8.38815 16.8046 8.38676C16.9639 8.38538 17.1219 8.41574 17.2694 8.47608C17.4169 8.53642 17.5508 8.62552 17.6635 8.73819C17.7762 8.85086 17.8653 8.98484 17.9256 9.13232C17.986 9.2798 18.0163 9.43781 18.0149 9.59715C18.0135 9.75648 17.9804 9.91394 17.9176 10.0603C17.8547 10.2068 17.7632 10.3392 17.6486 10.4499L12.8486 15.2499C12.6236 15.4748 12.3184 15.6012 12.0002 15.6012C11.682 15.6012 11.3769 15.4748 11.1518 15.2499L6.35183 10.4499C6.12687 10.2248 6.00049 9.91966 6.00049 9.60146C6.00049 9.28327 6.12687 8.9781 6.35183 8.75306Z"
                    fill="#2E2E2E"
                  />
                </svg>
              </button>

              <ul
                className="dropdown-menu shadow"
                aria-labelledby="dropdownMenuButton1"
              >
                <li>
                  <a
                    className="dropdown-item"
                    onClick={handleSortBy.bind(this, "name")}
                  >
                    {textIdentifier["name"][lang]}
                  </a>
                </li>

                <li>
                  <a
                    className="dropdown-item"
                    onClick={handleSortBy.bind(this, "rank")}
                  >
                    {textIdentifier["rank"][lang]}
                  </a>
                </li>
              </ul>
            </div>

            <div className="cr-search-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M19 19L13 13L19 19ZM15 8C15 8.91925 14.8189 9.82951 14.4672 10.6788C14.1154 11.5281 13.5998 12.2997 12.9497 12.9497C12.2997 13.5998 11.5281 14.1154 10.6788 14.4672C9.82951 14.8189 8.91925 15 8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.82951 1 8.91925 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8Z"
                  stroke="#2E2E2E"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <input
                className="form-control"
                placeholder={textIdentifier["search-by-school-name"][lang]}
                name="search"
                id="search"
                onInput={handleSearch}
              />
            </div>
            {showReportButton && (
              <div className="download-cta" onClick={handleDownloadReport}>
                  <div className="download-logo">
                    <img src="/static/images/svg/download-icon.svg" alt="download icon" />
                  </div>
                  <div className="download-text">
                    {textIdentifier["reports"][lang]}
                  </div>
               </div>
            )}
          </div>

          {filteredClasses.map((_, i) => {
            if (_.student_attempts) {
              return (
                <div className="cr-card" key={i}>
                  <div className="card-body">
                    <span>{i + 1}.</span>

                    <span>
                      {_.name}{" "}
                      <span className="text-primary">({textIdentifier["rank"][lang]} {_.rank})</span>
                    </span>

                    <a
                      className="icon"
                      onClick={() =>
                        selectClass(_, null, classes.length, false)
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                      >
                        <path
                          d="M15.75 8.75L28 21L15.75 33.25"
                          stroke="#2E2E2E"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              );
            } else {
              return (
                <div className="cr-card" key={i}>
                  <div className="card-body card-body-disabled">
                    <span>{i + 1}.</span>

                    <span>
                      {_.name}{" "}
                      <span className="text-primary">
                        ({textIdentifier["no-student-attempts"][lang]})
                      </span>
                    </span>

                    <div className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="42"
                        height="42"
                        viewBox="0 0 42 42"
                        fill="none"
                      >
                        <path
                          d="M15.75 8.75L28 21L15.75 33.25"
                          stroke="#CCCCCC"
                          stroke-width="3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              );
            }
          })}

          {filteredClasses.length === 0 && <h6>{textIdentifier["no-data-found"][lang]}</h6>}
        </div>
        {confirmDownloadModalOpen && <ConfirmDownloadReportModal language={lang} userData={userData} handleClose={handleCloseDownloadReportModal} downloadReportError={downloadReportError} downloadReportSuccess={downloadReportSuccess} downloadReportLoading={downloadReportLoading}/>}
      </main>
    </Fragment>
  );
}
